import {
  type ForumLinkResponse,
  type ThreadLatestPostResponse,
} from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import { PostFeedItem } from '@public/components/Forums/ForumItem';
import clsx from 'clsx';

import styles from './PostFeed.module.scss';

interface IPostFeedProps {
  posts: ThreadLatestPostResponse[];
  forum?: ForumLinkResponse;
  title?: string;
  links?: {
    url: string;
    text: string;
    title: string;
  }[];
  isModule?: boolean;
}

export const PostFeed = ({
  posts,
  forum,
  title = 'Message Board Posts',
  links = [],
  isModule = false,
}: IPostFeedProps) => {
  return (
    <section
      className={clsx(styles.block, {
        [styles.module]: isModule,
      })}
    >
      <h2 className={styles.heading}>{title}</h2>
      <ul className={styles.posts} data-post-feed-list>
        {posts?.map((post, index) => (
          <li key={index}>
            <PostFeedItem {...post} forum={forum} isModule={isModule} />
          </li>
        ))}
      </ul>
      {!!links?.length && (
        <footer className={styles.footer}>
          {links.map((link, index) => (
            <Link
              className={styles.link}
              href={link.url}
              key={index}
              title={link.title}
            >
              {link.text}
            </Link>
          ))}
        </footer>
      )}
    </section>
  );
};
